import {AuthService} from "./AuthService";

export const requestProbeProxyOptions = [
    {name: "no_proxy", label: "No Proxy", priority: 1},
    {name: "is_webshare_used", label: "Webshare", priority: 2},
    {name: "is_inhouse_unblocker_used", label: "In-House Unblocker", priority: 3},
    {name: "is_proxy_used", label: "Smart Proxy Manager", priority: 4},
    {name: "is_proxy_zyte_api_used", label: "Zyte API Proxy", priority: 5},
    {name: "is_scraperapi_used", label: "ScraperAPI Proxy", priority: 6}
];

export const requestProbeBaseSpiderOptions = [
    {name: "jsonbase", priority: 1},
    {name: "itemprop_base", priority: 2},
    {name: "magento_base", priority: 3},
    {name: "tcmaxbase", priority: 5},
    {name: "shopify_base", priority: 5},
    {name: "tsoftbase", priority: 6},
    {name: "ideasoft_v2_base", priority: 7},
    {name: "ideasoftbase", priority: 8},
    {name: "akilliticaretbase", priority: 10},
    {name: "akinsoftbase", priority: 10},
    {name: "dokuzyazilimbase", priority: 10},
    {name: "eticaretkurbase", priority: 10},
    {name: "hipotenusbase", priority: 10},
    {name: "imagazabase", priority: 10},
    {name: "kobimasterbase", priority: 10},
    {name: "marketyobase", priority: 10},
    {name: "platinmarketbase", priority: 10},
    {name: "projesoft_v1_base", priority: 10},
    {name: "projesoft_v2_base", priority: 10},
    {name: "softtrbase", priority: 10},
    {name: "yeditepesoftbase", priority: 10}
];

export class RequestProbeService {
    url = `request-probe/`;

    createProbe(url, request_type = "product_url", proxy_country = null, options = {}) {
        const payload = {
            url: url,
            request_type: request_type
        };
        if (proxy_country)
            payload.proxy_country = proxy_country;
        if (options.selected_proxies && options.selected_proxies.length > 0)
            payload.selected_proxies = options.selected_proxies;
        if (options.selected_base_spiders && options.selected_base_spiders.length > 0)
            payload.selected_base_spiders = options.selected_base_spiders;
        if (options.campaign_id)
            payload.campaign_id = options.campaign_id;
        if (options.search_keyword)
            payload.search_keyword = options.search_keyword;
        if (options.product_id)
            payload.product_id = options.product_id;
        if (options.search_url_template)
            payload.search_url_template = options.search_url_template;

        return AuthService.apiPost(this.url, payload).then(res => res.data.data);
    }

    getResult(website, request_type = "product_url") {
        return AuthService.apiGet(this.url + "result/", {
            params: {
                request_type: request_type,
                website: website
            }
        }).then(res => res.data.data);
    }

    listResults(params = {}) {
        return AuthService.apiGet(this.url + "results/", {params: params}).then(res => res.data.data);
    }

    archiveProbe(id, isArchived = true) {
        return AuthService.apiPost(this.url + id + "/archive/", {is_archived: isArchived}).then(res => res.data.data);
    }

    deleteProbe(id) {
        return AuthService.apiDelete(this.url + id + "/");
    }

    getResponseDownloadUrl(id, responseHash) {
        const downloadUrl = AuthService.coreApiURL + this.url + id + "/response/";
        return responseHash ? downloadUrl + "?response_hash=" + encodeURIComponent(responseHash) : downloadUrl;
    }

    getProductUrlResult(website) {
        return this.getResult(website, "product_url");
    }
}
